var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.98 17.407c1.876 8.3-8.714 9.843-14.243 9.578-4.838.608-15.686.752-20.374-3.535-5.86-5.36-.18-17.104 10.007-20.752C22.557-.951 34.637 7.03 36.98 17.407Z",
    fill: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 38,
    height: 27
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.98 17.407c1.876 8.3-8.714 9.843-14.243 9.578-4.838.608-15.686.752-20.374-3.535-5.86-5.36-.18-17.104 10.007-20.752C22.557-.951 34.637 7.03 36.98 17.407Z",
    fill: "#FBFBFB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A6AABC",
    d: "M17.7 24.994h1.564v4.843H17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.702 24.9h1.564v1.2h-1.564v-1.2Z",
    fill: "#8489A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6 25.2c5.634 0 10.2-4.567 10.2-10.2 0-5.633-4.566-10.2-10.2-10.2C12.967 4.8 8.4 9.367 8.4 15c0 5.633 4.567 10.2 10.2 10.2Zm4.643-12.403a.85.85 0 0 0-1.306-1.088L17.41 17.14 15.27 15a.85.85 0 1 0-1.203 1.202l2.064 2.063c.651.652.977.978 1.373.96.397-.018.692-.372 1.282-1.08l4.457-5.348Z",
    fill: "url(#b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 8.4,
    y1: 6.16,
    x2: 28.8,
    y2: 28.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09C649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63F996"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneSmallIcon);
export default __webpack_public_path__ + "static/media/done-small-icon.23092c2abb8e53e8ddd34b17f7a10139.svg";
export { ForwardRef as ReactComponent };